import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selectBrandId } from 'core/selectors/app';
import { getParamsFromSearch } from 'core/utils/helpers/getParamsFromSearch';

export const useGetBrandId = () => {
  const brandId = useSelector(selectBrandId);
  const location = useLocation();
  const { bid } = getParamsFromSearch(location.search);

  return bid || brandId;
};
